import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "@pd/pd-ui-kit";
import { get } from "lodash";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { useStaffFilterData } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { Field } from "~/shared/ui/Field";
import {
  addEducationalProgramValidationSchema,
  TAddEducationalProgramForm,
} from "~/widgets/Modals/AddEducationalProgram/model/config";

const addEducationalProgramFormId = "AddEducationalProgramForm";

interface IAddEducationalProgramProps {
  onSubmit: (value: TAddEducationalProgramForm) => void;
}

export const AddEducationalProgram = ({
  onSubmit,
}: IAddEducationalProgramProps) => {
  const { t } = useTranslation();
  const { openChildModal } = useGetLocationData();
  // Открытие/закрытие модалки — через replace, чтобы не плодить историю браузера
  const setDataReplace = useSetLocationData(true);

  const { control, handleSubmit, errors } = useForm<TAddEducationalProgramForm>(
    {
      resolver: yupResolver(addEducationalProgramValidationSchema(t)),
    },
  );

  const { positionsSelectOptionsList, positionsSelectMethods } =
    useStaffFilterData();

  const handleCloseModal = () => setDataReplace("openChildModal", "");

  const handlePopupScroll: React.UIEventHandler<HTMLDivElement> = (e) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 16) {
      positionsSelectMethods.onScrollBottom();
    }
  };

  return (
    <Modal
      open={openChildModal === "addEducationalProgram"}
      title={t("patp.add_educational_program")}
      onCancel={handleCloseModal}
      closable
      centered
      destroyOnHidden
      cancelButton={{ children: t("ui.cancel") }}
      okButton={{
        htmlType: "submit",
        form: addEducationalProgramFormId,
        children: t("ui.save"),
      }}
    >
      <form id={addEducationalProgramFormId} onSubmit={handleSubmit(onSubmit)}>
        <Field
          type="select"
          name="position"
          control={control}
          label={t("patp.position")}
          mode="multiple"
          // «Обход заглушки»: служебные опции с value === undefined
          // не показываем (как в useStaffFilterData для курсов)
          options={positionsSelectOptionsList
            .filter((el) => el.value !== undefined)
            .map((el) => ({
              label: String(el.label ?? ""),
              value: el.value as number,
            }))}
          loading={positionsSelectMethods.loading}
          showSearch
          filterOption={false}
          onSearch={positionsSelectMethods.searchText}
          onPopupScroll={handlePopupScroll}
          // errors.position по типу — массив (поле-мультиселект),
          // но ошибка валидации массива лежит в корне поля
          error={get(errors, "position.message")}
        />
      </form>
    </Modal>
  );
};
